/* eslint-disable @typescript-eslint/no-explicit-any */
import { Directive, Input, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[mTabIndex]',
  exportAs: 'mTabIndex'
})
export class MTabIndexDirective {
  templateRef = inject<TemplateRef<any>>(TemplateRef);

  @Input('mTabIndex') tabIndex = 0;
}
